import { Component } from '@theme/component';

class DisclosureCustom extends Component {
  requiredRefs = ['disclosureTrigger', 'disclosureContent'];

  connectedCallback() {
    super.connectedCallback();
    this._directClickHandler = (event) => {
      const trigger = this.refs.disclosureTrigger;
      if (trigger && (event.target === trigger || trigger.contains(event.target))) {
        this.toggleDisclosure(event);
      }
    };
    this.addEventListener('click', this._directClickHandler);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._directClickHandler) {
      this.removeEventListener('click', this._directClickHandler);
    }
  }

  toggleDisclosure = () => {
    const { disclosureTrigger: trigger, disclosureContent: content } = this.refs;
    const expanded = trigger.matches('[aria-expanded="true"]');
    trigger.setAttribute('aria-expanded', String(!expanded));
    trigger.setAttribute(
      'aria-label',
      expanded ? trigger.dataset.disclosureOpen : trigger.dataset.disclosureClose
    );
    content.inert = expanded;
  };
}

if (!customElements.get('disclosure-custom')) {
  customElements.define('disclosure-custom', DisclosureCustom);
}
